import React, { useState } from 'react'

const Logo = ({ className = "h-16 w-auto" }) => {
  const [logoError, setLogoError] = useState(false)
  
  // Try different logo formats in order of preference
  const logoFormats = [
    '/logo.png',   // Most preferred
    '/logo.jpg',   // Second choice
    '/logo.jpeg',  // Third choice
    '/logo.bmp'    // Last resort (limited browser support)
  ]
  
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0)
  
  const handleLogoError = () => {
    console.log(`Logo format ${logoFormats[currentLogoIndex]} failed to load`)
    
    if (currentLogoIndex < logoFormats.length - 1) {
      // Try next format
      setCurrentLogoIndex(currentLogoIndex + 1)
    } else {
      // All formats failed
      setLogoError(true)
      console.log('All logo formats failed to load')
    }
  }
  
  const handleLogoLoad = () => {
    console.log(`Logo loaded successfully: ${logoFormats[currentLogoIndex]}`)
    setLogoError(false)
  }
  
  if (logoError) {
    // Fallback: Show a styled text logo matching the brand colors
    return (
      <div className={`${className} flex items-center justify-center bg-logo-blue text-white rounded-lg px-4 py-2 mr-4 shadow-md`}>
        <div className="text-center">
          <div className="text-lg font-bold">אגוד</div>
          <div className="text-sm">הישיבות</div>
        </div>
      </div>
    )
  }
  
  return (
    <img 
      src={logoFormats[currentLogoIndex]}
      alt="Igud Hayeshivos Logo" 
      className={`${className} mr-4`}
      onError={handleLogoError}
      onLoad={handleLogoLoad}
    />
  )
}

export default Logo